"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixedLayout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const layout_1 = require("./layout.js");
function FixedLayoutComponent({ children }) {
    return (0, jsx_runtime_1.jsx)("div", { className: "koa:relative koa:flex koa:h-dvh koa:flex-col koa:overflow-hidden koa:pb-6", children: children });
}
FixedLayoutComponent.displayName = "FixedLayout";
exports.FixedLayout = Object.assign(FixedLayoutComponent, {
    Header: layout_1.Layout.Header,
    Content: layout_1.Layout.Content,
    Footer: layout_1.Layout.Footer,
});
